import { render, staticRenderFns } from "./FolderForm.vue?vue&type=template&id=0d2cf1bc&scoped=true&"
import script from "./FolderForm.vue?vue&type=script&lang=ts&"
export * from "./FolderForm.vue?vue&type=script&lang=ts&"
import style0 from "./FolderForm.vue?vue&type=style&index=0&id=0d2cf1bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2cf1bc",
  null
  
)

export default component.exports